import React, { Component } from "react";
import { Button, Row } from 'reactstrap';
import Switch from "COMPONENTS/CommonComponents/Switch/Switch";
import toastr from 'COMPONENTS/ShowTostr/ShowTostr';

import "./CustomerCoBrowse.less";
import { getMessage } from "CONFIG/i18n";
import { postMesageToCoBrowseIframeUtility, isMobileOriPad } from "UTILS/Utility";
import { customerCoBrowseAction } from "CONFIG/ActionFactory";
import ic_plus from "ASSETS/Images/ic_zoom_in.svg";
import ic_minus from "ASSETS/Images/ic_zoom_out.svg";
import EndCobrowseConfirmationModal from "COMPONENTS/CommonComponents/Modal/Modal";
import ScreenMaskingContainer from "COMPONENTS/ScreenMasking/ScreenMaskingContainer"
import { CUSTOMER_CO_BROWSE_ACTIONS, CUSTOMER_CO_BROWSE_RESPONSE,
  COMPONENT_IN_FOCUS, CO_BROWSE_LAYOUT, USER_ROLES } from "../../Utils/Constants";

const ZOOM = {
  PLUS: 0.2,
  MINUS: -0.2,
  MAX: 4.0,
  MIN: 0.4
}

class CustomerCoBrowse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showEndCobrowseConfirmationModal: false,
      isFollowerEdit: this.props.presenterSelectMutualEdit,
      orientation: null,
      zoom: 1.0
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isScreenMasking !== this.props.isScreenMasking) {
      this.resizeScreenMasking();
    }
  }

  componentDidMount = () => {
    this.setCoBrowseElementsLayout();
    window.addEventListener("resize", this.setCoBrowseElementsLayout);
    window.addEventListener("message", this.coBrowseMessageListener, false);
    if (this.props.componentInFocus !== COMPONENT_IN_FOCUS.CANVAS) {
      this.props.setComponentInFocus(COMPONENT_IN_FOCUS.CANVAS);
    }
    this.resizeScreenMasking();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.setCoBrowseElementsLayout);
    document.removeEventListener('click', this.handleOutsideClickEndMeeting);
    window.removeEventListener("message", this.coBrowseMessageListener, false);
  }

  coBrowseMessageListener = (event) => {
    this.getIframeMsg(event);
  }

  setCoBrowseElementsLayout =() => {
    if (!isMobileOriPad()
     || isMobileOriPad() && this.state.orientation !== window.orientation) {
      setTimeout(() => {
        this.setIframeDimensions();
        this.resizeScreenMasking();
      }, 100);
    }
    this.setState({
      orientation: window.orientation
    });
  }

  getIframeMsg = (event) => {
    if (event.origin == this.props.coBrowseBaseUrl
      && event.data
      && event.data.viewAction == CUSTOMER_CO_BROWSE_ACTIONS.CO_BROWSER_END
      && !this.props.endCustomerCBSession) { // don't send END_SESSION ws message if page refreshed as here we are closing session without confirmation
      console.log("End session response:", event.data);

      switch (event.data.result) {
        case CUSTOMER_CO_BROWSE_RESPONSE.END_FAIL:
        case CUSTOMER_CO_BROWSE_RESPONSE.END_SUCCESS:
          console.log("End session success response:", event.data.result);
          if (this.props.isPresenter()) {
            this.props.handleCustomerCoBrowseEndSessionClick();
          } else {
            this.props.handleCustomerCoBrowseLeaveSessionClick();
          }
          break;
        case CUSTOMER_CO_BROWSE_RESPONSE.END_CANCEL:
          console.log("End session cancelled:", event.data);
          break;
        default:
          console.log("End session default call:", event.data);
          break;
      }
    }
  }

  setIframeDimensions = (_zoom) => {
    let zoom = _zoom ? _zoom : this.state.zoom;
    let iframe = document.getElementById("customerCBIframe");
    let iframeDiv = document.getElementById("customerCBIframeContainer");
    if (!iframe || !iframeDiv) {
      return;
    }
    let iframeTop = iframe.offsetTop;
    let iframeHeightBeforeScale = screen.height;
    let iframeWidthBeforeScale = screen.width;

    let scaleFactor;
    let widthScaleFactor;
    if (this.props.layoutCode == CO_BROWSE_LAYOUT.laptop) {
      iframeHeightBeforeScale = 900;
      iframeWidthBeforeScale = 1600;
      iframe.style.width = iframeWidthBeforeScale + 'px';
      iframe.style.height = iframeHeightBeforeScale + 'px';
      iframeTop = 0;
      scaleFactor = iframeDiv.offsetHeight / iframeHeightBeforeScale;
      widthScaleFactor = iframeDiv.offsetWidth / iframeWidthBeforeScale;
      if (iframeDiv.offsetWidth <= 992) {
        iframe.style.transform = `scale(${widthScaleFactor * zoom})`;
      } else {
        iframe.style.transform = `scale(${scaleFactor * zoom})`;
      }
      // iframe.style.top = iframeTop + (((iframeHeightBeforeScale * scaleFactor) - iframeHeightBeforeScale) / 2) + 'px';
      // Position an iframe during PC layout
      let iframeDivOffsetWidth = iframeDiv.offsetWidth;
      let iframeDivOffsetHight = iframeDiv.offsetHeight;
      // let topValue = parseFloat((iframeDivOffsetHight-(scaleFactor*iframeHeightBeforeScale))/2);
      // iframe.style.top = topValue + 'px';
      let leftValue = parseFloat((iframeDivOffsetWidth - (scaleFactor * iframeWidthBeforeScale)) / 2);
      iframe.style.left = (iframeDiv.offsetWidth <= 992) ? "0px" : leftValue + "px";
      // Sets the X = 0, y = 0 position of the iframe to the origin of the change
      iframe.style.transformOrigin = "0% 0%";
    } else if (this.props.layoutCode == CO_BROWSE_LAYOUT.tablet) {
      iframeHeightBeforeScale = 1440;
      iframeWidthBeforeScale = 1024;
      iframe.style.width = iframeWidthBeforeScale + 'px';
      iframe.style.height = iframeHeightBeforeScale + 'px';
      iframeTop = 0;
      scaleFactor = iframeDiv.offsetHeight / iframeHeightBeforeScale;
      widthScaleFactor = iframeDiv.offsetWidth / iframeWidthBeforeScale;
      if (iframeDiv.offsetWidth <= 480) {
        iframe.style.transform = `scale(${widthScaleFactor * zoom})`;
      } else {
        iframe.style.transform = `scale(${scaleFactor * zoom})`;
      }
      // iframe.style.top = iframeTop + (((iframeHeightBeforeScale * scaleFactor) - iframeHeightBeforeScale) / 2) + 'px';
      // Position an iframe during tablet layout
      let iframeDivOffsetWidth = iframeDiv.offsetWidth;
      let iframeDivOffsetHight = iframeDiv.offsetHeight;
      let topValue = parseFloat((iframeDivOffsetHight - (scaleFactor * iframeHeightBeforeScale)) / 2);
      iframe.style.top = topValue + 'px';
      // Since the tablet layout is displayed in the center next to the parent layout, and there are left and right blanks, set the X half of the iframe, y = 0 position to the origin of the change.
      iframe.style.transformOrigin = "50% 0%";
    } else if (this.props.layoutCode == CO_BROWSE_LAYOUT.mobileVertical) {
      iframeHeightBeforeScale = 640;
      iframeWidthBeforeScale = 360;
      iframe.style.width = iframeWidthBeforeScale + 'px';
      iframe.style.height = iframeHeightBeforeScale + 'px';
      iframeTop = 0;
      scaleFactor = iframeDiv.offsetHeight / iframeHeightBeforeScale;
      iframe.style.transform = `scale(${scaleFactor * zoom})`;
      // iframe.style.top = iframeTop + (((iframeHeightBeforeScale * scaleFactor) - iframeHeightBeforeScale) / 2) + 'px';
      let iframeDivOffsetHight = iframeDiv.offsetHeight;
      let topValue = parseFloat((iframeDivOffsetHight - (scaleFactor * iframeHeightBeforeScale)) / 2);
      iframe.style.top = topValue + 'px';
      // Since the tablet layout is displayed in the center next to the parent layout, and there are left and right blanks, set the X half of the iframe, y = 0 position to the origin of the change.
      iframe.style.transformOrigin = "50% 0%";
    } else if (this.props.layoutCode == CO_BROWSE_LAYOUT.mobileHorizontal) {
      iframeHeightBeforeScale = 360;
      iframeWidthBeforeScale = 640;
      iframeTop = 0;
      iframe.style.width = iframeWidthBeforeScale + "px";
      iframe.style.height = iframeHeightBeforeScale + "px";
      scaleFactor = iframeDiv.offsetHeight / iframeHeightBeforeScale;
      widthScaleFactor = iframeDiv.offsetWidth / iframeWidthBeforeScale;
      if (iframeDiv.offsetWidth <= 992) {
        iframe.style.transform = `scale(${widthScaleFactor * zoom})`;
      } else {
        iframe.style.transform = `scale(${scaleFactor * zoom})`;
      }
      // iframe.style.left = "20%";
      // iframe.style.transform = "none";
      // scaleFactor = (iframeDiv.offsetHeight - 10) / iframeHeightBeforeScale;
      // iframe.style.top = iframeTop + (((iframeHeightBeforeScale * scaleFactor) - iframeHeightBeforeScale) / 2) + 'px';
      // Position iframe during mobile (horizontal) layout
      let iframeDivOffsetWidth = iframeDiv.offsetWidth;
      let iframeDivOffsetHight = iframeDiv.offsetHeight;
      let topValue = parseFloat((iframeDivOffsetHight - (scaleFactor * iframeHeightBeforeScale)) / 2);
      iframe.style.top = topValue + 'px';
      let leftValue = parseFloat((iframeDivOffsetWidth - (scaleFactor * iframeWidthBeforeScale)) / 2);
      iframe.style.left = (iframeDiv.offsetWidth <= 992) ? null : leftValue + "px";
      // Sets the X = 0, y = 0 position of the iframe to the origin of the change
      iframe.style.transformOrigin = (iframeDiv.offsetWidth <= 992) ? "50% 0%" : "0% 0%";
    }
  }

  getCoBrowseSessionUrl = () => {
    let sessionUrl = this.props.isPresenter() ?
      this.props.coBrowseBaseUrl + "/cobrowse/#/session?roomId=" + this.props.roomId + "&token=" + this.props.token + "&userName=" + this.props.userName + "&sessionKey=" + this.props.sessionKey :
      this.props.coBrowseBaseUrl + "/cobrowse/#/" + this.props.shareUrl + "&token=" + this.props.token + "&userName=" + this.props.userName + "&sessionKey=" + this.props.sessionKey;
    return sessionUrl;
  }

  handleOutsideClickEndMeeting = (event) => {
    if (event.target.className == 'modal fade show') {
      this.setState({
        showEndCobrowseConfirmationModal: false
      });
      document.removeEventListener('click', this.handleOutsideClickEndMeeting);
    }
  }

  onOpenCloseEndCobrowseConfirmationModal = (modalState) => {
    if (modalState && !navigator.onLine) {
      toastr.error(getMessage("NETWORK_ERROR"));
      return;
    }
    this.setState({
      showEndCobrowseConfirmationModal: modalState
    });
    this.handleOutsideClickEndMeeting = this.handleOutsideClickEndMeeting.bind(this);
    document.addEventListener('click', this.handleOutsideClickEndMeeting);
  }

  handleEndLeaveCBSessionClick = () => {
    postMesageToCoBrowseIframeUtility(this.props.token, this.props.coBrowseBaseUrl);
  }

  iframeTransform = (zoom) => {
    if (((this.state.zoom + zoom) < ZOOM.MIN) || ((this.state.zoom + zoom) > ZOOM.MAX)) {
      return;
    }
    this.setIframeDimensions(this.state.zoom + zoom);
    this.setState({ zoom: this.state.zoom + zoom });
    this.resizeScreenMasking();
    /*
    let iframe = document.getElementById("customerCBIframe");
    let iframeDiv = document.getElementById("customerCBIframeContainer");
    if (!iframe || !iframeDiv) {
      return;
    }
    let transform = iframe.style.transform;
    transform = parseFloat(transform.match(/\(([^)]*)\)/)[1]);
    if (((transform + zoom) < ZOOM.MIN) || ((transform + zoom) > ZOOM.MAX)) {
      return;
    }
    const scaleFactor = transform;
    const iframeOffsetWidth = iframe.offsetWidth;
    const iframeDivOffsetWidth = iframeDiv.offsetWidth;
    if ((iframeOffsetWidth * scaleFactor) > iframeDivOffsetWidth) {
      iframe.style.left = "0px";
      iframe.style.transformOrigin = "0% 0%";
    } else {
      iframe.style.left = "";
      iframe.style.transformOrigin = "50% 0%";
    }
    iframe.style.transform = `scale(${scaleFactor})`;
    */
  }

  iframeLoaded = () => {
    console.log('Customer Co-browse iframe loaded successfully');
    // TODO: remove setTimeout once CB side issue fixed (issue: user ending session when iframe is loading)
    if (this.props.endCustomerCBSession && this.props.showCustomerCoBrowse && this.props.token && this.props.coBrowseBaseUrl) {
      setTimeout(() => {
        console.log("End_session_without_confirmation on page refresh");
        postMesageToCoBrowseIframeUtility(this.props.token, this.props.coBrowseBaseUrl);
        this.closeCustomerCbContainer();
      }, 1500); // 1.5sec delay required until iframe gets loaded completely... takes 1.5sec to load iframe
    }
  }

  closeCustomerCbContainer = () => {
    setTimeout(() => {
      if (this.props.isPresenter()) {
        customerCoBrowseAction.endCustomerCoBrowse();
      } else {
        customerCoBrowseAction.leaveCustomerCoBrowse(this.props.uniqueId);
      }
    }, 500); // wait until message gets posted to CB properly then close CB container.... and after 2 sec will have to close cb container
  }

  /**
   * Control from the agent user
   * ON: only followers can edit themselves, owner cannot edit
   * OFF: only the owner can edit himself, cannot edit followers
   */
  followerEditSwitchListener = (toggleFlag) => {
    this.setState({
      isFollowerEdit: toggleFlag
    });

    const iframeEle = document.getElementById("customerCBIframe");
    if (iframeEle) {
      const iframe = iframeEle.contentWindow;
      const msg = {
        action: "Change_edit",
        userName: toggleFlag ? "follower" : "owner"
      };
      console.log(this.props.coBrowseBaseUrl);
      iframe.postMessage(msg, this.props.coBrowseBaseUrl);
    }
  }

  resizeScreenMasking = () => {
    let customerCoBrowse = document.getElementById('customerCoBrowse');
    let customerCBIframeContainer = document.getElementById('customerCBIframeContainer');
    if (customerCoBrowse && customerCBIframeContainer) {
      if (this.props.presenterId === this.props.uniqueId) {
        if (this.props.isScreenMasking) {
          if (!customerCoBrowse.style.height) {
            customerCoBrowse.style.height = customerCoBrowse.offsetHeight + 30 + 'px';
          }
          if (!customerCBIframeContainer.style.height) {
            customerCBIframeContainer.style.height = customerCBIframeContainer.offsetHeight - 30 + 'px';
          }
        } else {
          customerCoBrowse.style.height = '';
          customerCBIframeContainer.style.height = '';
        }
      }
    }

    const customerCBIframe = document.getElementById("customerCBIframe");
    const screenMaskingDiv = document.querySelector("#customerCoBrowse .screenMaskingDiv");
    if (customerCBIframe && customerCBIframeContainer && screenMaskingDiv) {
      if (this.props.isScreenMasking && !(this.props.presenterId === this.props.uniqueId)) {
        screenMaskingDiv.style.height = customerCBIframeContainer.offsetHeight + 2 + 'px';
        screenMaskingDiv.style.width = customerCBIframeContainer.offsetWidth + 2 + 'px';
        if (!isMobileOriPad()) {
          screenMaskingDiv.style.position = 'fixed';
        }
        customerCBIframe.style.visibility = 'hidden';
        customerCBIframeContainer.style.overflow = 'hidden';
      } else {
        screenMaskingDiv.style.height = '0px';
        screenMaskingDiv.style.width = '';
        screenMaskingDiv.style.position = 'absolute';
        customerCBIframe.style.visibility = '';
        customerCBIframeContainer.style.overflow = '';
      }
    }
  }

  render() {
    return (
      <div id="customerCoBrowse" className="pt-1 paddingBottomCustomerCoBrowse">
        <div className="row px-1 m-0 justify-content-end d-flex">
          {((this.props.role === USER_ROLES.AGENT) && this.props.mutualEdit) &&
            <div>
              <Row className="px-1 m-0">
                <div style={{ color: "#fff", paddingTop: "2px" }}>
                  {getMessage("EDIT_FOLLOWER")}&nbsp;
                </div>
                <div style={{ paddingRight: "15px" }}>
                  <Switch
                    switchOn={this.state.isFollowerEdit}
                    toggleSwitch={(event) => { this.followerEditSwitchListener(event); }}
                  />
                </div>
              </Row>
            </div>
          }

          <div className="displayFlex pb-1">
            { !isMobileOriPad() &&
              <div style={{ margin: "auto", paddingRight: "15px" }}>
                <img
                  src={ic_minus}
                  className="py-1 btn zoomBtn"
                  onClick={() => this.iframeTransform(ZOOM.MINUS)}
                  title={getMessage("ZOOMOUT")}
                />
                <img
                  src={ic_plus}
                  className="py-1 btn zoomBtn"
                  onClick={() => this.iframeTransform(ZOOM.PLUS)}
                  title={getMessage("ZOOMIN")}
                />
              </div>
            }

            <Button
              id="endSessionBtn"
              className="btn-close"
              type="button"
              close
              aria-label="Cancel"
              onClick={() => this.onOpenCloseEndCobrowseConfirmationModal(true)}
              title={getMessage("END_CO_BROWSE")}
            />

            {
              this.state.showEndCobrowseConfirmationModal &&
              <EndCobrowseConfirmationModal
                show={true}
                isDoubleButton={true}
                handleYesClick={() => {
                  this.onOpenCloseEndCobrowseConfirmationModal(false);
                  this.handleEndLeaveCBSessionClick();
                }}
                handleNoClick={() => { this.onOpenCloseEndCobrowseConfirmationModal(false); }}
                message={
                  this.props.isPresenter() ? getMessage("END_COBROWSE_CONFIRMATION_TEXT_PRESENTER") : getMessage("END_COBROWSE_CONFIRMATION_TEXT")
                }
              />
            }

          </div>
        </div>
        {
          this.props.isScreenMasking && (this.props.presenterId === this.props.uniqueId) ? (
            <div className="presenterMsgDiv">
              <span className="presenterMsg">
                {getMessage("YOUR_SCREEN_MASKED")}
              </span>
            </div>
          ) : null
        }
        <div id="customerCBIframeContainer" className="customerCBIframeContainer d-flex align-items-center justify-content-center">
          <ScreenMaskingContainer
            presenterId={this.props.presenterId}
            uniqueId={this.props.uniqueId}
          />
          <iframe
            name="customerCBIframe"
            id="customerCBIframe"
            title="customerCoBrowse"
            src={this.getCoBrowseSessionUrl()}
            height="100%"
            width="100%"
            onLoad={this.iframeLoaded}
          />
        </div>
      </div>
    );
  }
}

export default CustomerCoBrowse;
